import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setEnableNativeAppConfirmation } from '../../Redux/ActionCreator';

const LDContextUpdate = () => {
    const ldClient = useLDClient();
    const dispatch = useDispatch();
    const { country, bac } = useSelector((state) => state.prefillReducer);
    const dealerSummaryObject = useSelector((state) => state.prefillReducer.dealerSummaryObject);
    const dmsTradingPartnerId = dealerSummaryObject?.dmsTradingPartnerId ?? '';

    useEffect(() => {
        if (country && bac && ldClient) {
            const newMultiContext = {
                kind: 'multi',
                user: {
                    key: 'app-user-46679',
                    country: country,
                    dmsVendor: dmsTradingPartnerId,
                },
                dealership: {
                    key: 'app-dealership-46679',
                    bac: bac,
                },
            };

            ldClient.identify(newMultiContext);

            const enableNativeAppConfirmation = ldClient.variation('enableNativeAppConfirmation', false);
            dispatch(setEnableNativeAppConfirmation(enableNativeAppConfirmation));
        }
    }, [country, bac, ldClient, dmsTradingPartnerId]);

    return <></>;
};

export default LDContextUpdate;
